import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { HeaderModule } from 'src/app/_component/header/header.module';

import { TranslateModule } from '@ngx-translate/core';
import { NgApexchartsModule } from 'ng-apexcharts';
import { LoadingStiModule } from 'src/app/_component/loading-sti/loading-sti.module';
import { SharedDirectivesModule } from 'src/app/_directives/shared-directives.module';
import { PipesModule } from 'src/app/_pipes/pipes.module';
import { DateTimePickerComponentModule } from '../../_component/date-time-picker/date-time-picker.module';
import { NoResultModule } from '../../_component/no-result/no-result.module';
import { PaginationClientSideModule } from '../../_component/pagination-client-side/pagination-client-side.module';
import { SelectDropdownModule } from '../../_component/select-dropdown/select-dropdown.module';
import { ListHeaderComponentModule } from '../../_component/_structural/list-header/list-header.module';
import { MobileFilterComponentModule } from '../../_component/_structural/mobile-filter/mobile-filter.module';
import { GuestReportModalFilterComponentModule } from './guest-report-modal-filter/guest-report-modal-filter.module';
import { GuestReportViewComponentModule } from './guest-report-view/guest-report-view.module';
import { GuestReportComponent } from './guest-report.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    HeaderModule,
    ListHeaderComponentModule,
    SelectDropdownModule,
    PaginationClientSideModule,
    DateTimePickerComponentModule,
    LoadingStiModule,
    NoResultModule,
    TranslateModule,
    GuestReportViewComponentModule,
    PipesModule,
    MobileFilterComponentModule,
    NgApexchartsModule,
    SharedDirectivesModule,
    GuestReportModalFilterComponentModule
  ],
  declarations: [GuestReportComponent],
  exports: [GuestReportComponent]
})
export class GuestReportViewModule {}
